import { Dayjs } from 'dayjs';
import { IOPointRoute } from './metconsole.types';
import { GeoLayer } from './geoserver.types';
import { utcDayjs } from '../utils';

export type ViewMode = 'layer' | 'tile';
export type Origin = 'map' | 'chart';
export type State = 'ready' | 'active' | 'shaded' | 'ended';

export enum Role {
  METEO = 'meteo',
  SUPERVISOR = 'supervisor'
}

export enum FloatingWindowType {
    Products = 'product',
    Alarms = 'alarms',
    Time = 'time'
}

export interface FloatingWindow {
    title?: string,
    top: number,
    left: number,
    index: string,
    type: FloatingWindowType
}

export interface ColorStep {
  color: number[],
  threshold: number
}

export interface ColorScale {
  name: string,
  steps: ColorStep[]
}

export interface DataType {
  name: string,
  colorScales: ColorScale[]
}

type GeoLayerLike = GeoLayer;
/* export interface IProduct {
    index: number;
    workspace: string,
    name: string,
    internalName: string,
    layer: GeoLayerLike,
    currentStyle: string;
    currentOpacity?: number;
    currentElevation?: number;
    currentDate?: Dayjs;
    capabilities?: LayerElement;
} */

export type BaseLayerType = 'default' | 'label' | 'aux'

export type IOPointData = IOPointRoute;

export interface InterestPoint {
  lon: number,
  lat: number,
}

interface AreaCoordinates {
  name: string;
  order: number;
  coordinates: number[][];
}

export interface ConnectedLayerConfig {
  interestPoints: InterestPoint[],
  iopointData: Omit<IOPointData, 'service'>,
  fetchInterval: number,
  maximunRangeToAskForCompleteAlarmsInSeconds?: number,
  areasCoordinates: AreaCoordinates[],
}

export interface BaseLayerConfig {
  level: number,
  layerName: string,
  name: string,
  defaultSelected: boolean
  tiled: boolean,
  minZoom: number,
  type: BaseLayerType,
  connected?: boolean,
  config?: ConnectedLayerConfig,
  /** Custom tile URL template. If provided, overrides the default static service URL. */
  url?: string,
}

export type DataProvider = 'geoserver' | 'dtn';

export class Product {
  id: string;

  index: number;

  workspace: string;

  name: string;

  internalName: string;

  layer: GeoLayerLike;

  currentStyle: string;

  currentOpacity?: number;

  currentElevation?: number;

  currentDate?: Dayjs;

  /** Identifies the data source. Defaults to 'geoserver' when absent. */
  provider?: DataProvider;

  constructor(product: Partial<Product> & Pick<Product, 'index' | 'internalName' | 'workspace' | 'name' | 'currentStyle' | 'layer'>) {
    this.id = product.id || `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
    this.index = product.index;
    this.internalName = product.internalName;
    this.workspace = product.workspace;
    this.name = product.name;
    this.currentStyle = product.currentStyle;
    this.currentOpacity = product.currentOpacity || 80;
    this.layer = product.layer;
    if (typeof product.currentDate === 'string') {
      this.currentDate = utcDayjs(product.currentDate);
    } else {
      this.currentDate = product.currentDate;
    }
    this.currentElevation = product.currentElevation;
    this.provider = product.provider;
  }

  setCurrentStyle(style: string) {
    this.currentStyle = style;
  }

  setCurrentOpacity(opacity: number) {
    this.currentOpacity = opacity;
  }

  setCurrentDate(date: Dayjs) {
    this.currentDate = date;
  }

  setCurrentElevation(elevation: number) {
    this.currentElevation = elevation;
  }
}
